import { configQuery, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate } from 'tslib';
import { Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import Component from 'vue-class-component';
import { notificationService, NotificationStyle } from '@gig/magic-messaging';

var PeriodicAccountReviewComponent = /** @class */ (function (_super) {
    __extends(PeriodicAccountReviewComponent, _super);
    function PeriodicAccountReviewComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.options = [];
        _this.duration = null;
        _this.isSubmitting = false;
        return _this;
    }
    PeriodicAccountReviewComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUserOptions()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.setDefaultDurationFromProfile()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PeriodicAccountReviewComponent.prototype.getUserOptions = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var options;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, configQuery('periodicAccountReviewDurations')];
                    case 1:
                        options = (_a = (_b.sent())) !== null && _a !== void 0 ? _a : [];
                        this.options = options.sort(function (a, b) { return a - b; });
                        return [2 /*return*/];
                }
            });
        });
    };
    PeriodicAccountReviewComponent.prototype.submitPeriodicInterval = function () {
        return __awaiter(this, void 0, void 0, function () {
            var interval, nowIso, response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isSubmitting) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.isSubmitting = true;
                        interval = this.getIntervalForDuration(this.duration);
                        nowIso = new Date().toISOString();
                        return [4 /*yield*/, magic.methods.users.updateUserProfile({
                                lastAccountReviewInterval: interval,
                                lastAccountReviewOnUtc: nowIso,
                            })];
                    case 2:
                        response = _a.sent();
                        if (response) {
                            notificationService.show(this.$t('periodic-account-review.success'), {
                                style: NotificationStyle.SUCCESS,
                                uniqueID: 'periodic-account-review.success',
                            });
                        }
                        else {
                            this.showErrorNotification();
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        console.log('error', e_1);
                        this.showErrorNotification();
                        return [3 /*break*/, 5];
                    case 4:
                        this.isSubmitting = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    PeriodicAccountReviewComponent.prototype.showErrorNotification = function () {
        notificationService.show(this.$t('error.generic'), {
            style: NotificationStyle.ERROR,
            uniqueID: 'periodic-account-review-error-generic',
        });
    };
    PeriodicAccountReviewComponent.prototype.setDefaultDurationFromProfile = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var profileData, savedInterval, match, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, magic.methods.users.getUserProfile()];
                    case 1:
                        profileData = _b.sent();
                        savedInterval = profileData === null || profileData === void 0 ? void 0 : profileData.consents.lastAccountReviewInterval;
                        if (savedInterval) {
                            match = savedInterval.match(/P(\d+)M/);
                            if (match) {
                                this.duration = match[1];
                                return [2 /*return*/];
                            }
                        }
                        if (this.options.includes(6)) {
                            this.duration = '6';
                        }
                        else {
                            this.duration = String((_a = this.options[0]) !== null && _a !== void 0 ? _a : '');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _b.sent();
                        console.error('Failed to get user profile', e_2);
                        this.duration = '6';
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PeriodicAccountReviewComponent.prototype.getIntervalForDuration = function (duration) {
        if (duration === '0') {
            return null;
        }
        return "P" + duration + "M";
    };
    PeriodicAccountReviewComponent = __decorate([
        Component({
            name: 'corex-periodic-account-review',
        })
    ], PeriodicAccountReviewComponent);
    return PeriodicAccountReviewComponent;
}(Mixins(MagicConfigMixin)));

export default PeriodicAccountReviewComponent;
